module.exports = __webpack_public_path__ + "img/virgin_islands_br.9637b7e.webp";